import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../../../../Assets/Styles/Notifications.scss";
import { Config } from "../../../../Config";
import Deletemodal from "./Components/DeleteModal";
import EmptyState from "./Components/EmptyState";
import NotificationItem from "./Components/NotificationItem";

const Notifications = (props) => {
  const [TabIds] = useState(["events-notifs-tab", "messages-notifs-tab"]);
  const [ListIds] = useState(["event-notifs", "message-notifs"]);
  const [ActiveTab, setActiveTab] = useState("events"); //"events" or  "messages"
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);
  const [DeleteModal, setDeleteModal] = useState({
    isOpen: false,
    type: "events",
  });

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("notfications-wrapper").classList.add("is-open");
    }, 150);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const toggleClose = () => {
    document.getElementById("notfications-wrapper").classList.remove("is-open");
    setTimeout(() => {
      props.Close();
    }, 500);
  };

  const handleSelectTab = (TabId) => {
    setContextMenuIsOpen(false);

    TabIds.map((Tab) => {
      document.getElementById(Tab).classList.remove("active-tab");
    });
    document.getElementById(TabId).classList.add("active-tab");
    if (TabId === TabIds[0]) {
      //events tab is clicked
      document.getElementById(ListIds[0]).classList.remove("hidden");
      document.getElementById(ListIds[0]).classList.add("transformed");
      document.getElementById(ListIds[1]).classList.add("hidden");
      document.getElementById(ListIds[1]).classList.remove("transformed");
      document.getElementById("notif-tab-indicator").style.transform = "none";
      setActiveTab("events");
    } else {
      // messages tab is clicked
      document.getElementById(ListIds[0]).classList.add("hidden");
      document.getElementById(ListIds[0]).classList.remove("transformed");
      document.getElementById(ListIds[1]).classList.remove("hidden");
      document.getElementById(ListIds[1]).classList.add("transformed");
      document.getElementById("notif-tab-indicator").style.transform =
        "translateX(96px)";
      setActiveTab("messages");
    }
  };

  const markAllAsRead = () => {
    let ActiveTab;
    TabIds.map((Item) => {
      if (document.getElementById(Item).classList.contains("active-tab")) {
        ActiveTab = Item;
      }
    });
    if (ActiveTab === "events-notifs-tab") {
      markAllEventsAsRead();
    } else {
      markAllMessagesNotifAsRead();
    }
  };

  const markAllEventsAsRead = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/events/status/read-all",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.UpdateEventsList();
        setContextMenuIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const markAllMessagesNotifAsRead = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/messages/status/read-all",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.UpdateMessagesList();
        setContextMenuIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleDelete = (Type) => {
    setContextMenuIsOpen(false);
    setDeleteModal({ isOpen: true, type: Type });
  };
  const confirmDelete = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/" +
        DeleteModal.type +
        "/status/delete-all",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteModal({ isOpen: false, type: DeleteModal.type });
        props.UpdateMessagesList();
        props.UpdateEventsList();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <div className="notifications">
      <NavLink
        hidden
        to="/communication"
        id="notif-communication-toggle"
      ></NavLink>
      <NavLink
        hidden
        to={props.IsMSS || props.IsSuperAdmin ? "/ess" : "/"}
        id="notif-home-toggle"
      ></NavLink>
      <NavLink hidden to="/JobDetails" id="notif-vacancies-toggle"></NavLink>
      <NavLink hidden to="/ProjectDetails" id="notif-projects-toggle"></NavLink>
      <NavLink
        hidden
        to="/vacancyCandidates"
        id="notif-job-candidates-toggle"
      ></NavLink>
      <NavLink
        hidden
        to="/projectCandidates"
        id="notif-project-candidates-toggle"
      ></NavLink>
      <NavLink
        hidden
        to="/activityCandidates"
        id="notif-activity-candidates-toggle"
      ></NavLink>
      <NavLink
        hidden
        to="/ActivityDetails"
        id="notif-activities-toggle"
      ></NavLink>
      {DeleteModal.isOpen ? (
        <Deletemodal
          Close={() =>
            setDeleteModal({ isOpen: false, type: DeleteModal.type })
          }
          Confirm={() => confirmDelete()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="overlay">
        <div className="outline" onClick={() => toggleClose()}></div>
        <section className="notifications-main" id="notfications-wrapper">
          <div className="notifications-head">
            <i className="feather-x" onClick={() => toggleClose()}></i>
            <h2 className="title-text">{translateText("notifications")}</h2>
            {ActiveTab === "events" ? (
              <>
                <button
                  className="context-menu-toggle"
                  onClick={() => setContextMenuIsOpen(true)}
                >
                  <i className="feather-more-vertical"></i>
                </button>
                {ContextMenuIsOpen ? (
                  <>
                    <div
                      className="outline"
                      onClick={() => setContextMenuIsOpen(false)}
                    ></div>
                    <div className="context-menu-content">
                      <section
                        className="menu-row menu-row-red "
                        onClick={() => toggleDelete("events")}
                      >
                        <i className="feather-trash-2"></i>{" "}
                        {translateText("delete_all")}
                      </section>
                      <section
                        className={
                          props.HasEventsNotifications
                            ? "menu-row"
                            : "menu-row menu-row-disable"
                        }
                        onClick={() => markAllEventsAsRead()}
                      >
                        <i className="feather-check"></i>{" "}
                        {translateText("mark_all_as_read")}
                      </section>
                    </div>
                  </>
                ) : null}
              </>
            ) : (
              <>
                <button
                  className="context-menu-toggle"
                  onClick={() => setContextMenuIsOpen(true)}
                >
                  <i className="feather-more-vertical"></i>
                </button>
                {ContextMenuIsOpen ? (
                  <>
                    <div
                      className="outline"
                      onClick={() => setContextMenuIsOpen(false)}
                    ></div>
                    <div className="context-menu-content">
                      <section
                        className="menu-row menu-row-red "
                        onClick={() => toggleDelete("messages")}
                      >
                        <i className="feather-trash-2"></i>{" "}
                        {translateText("delete_all")}
                      </section>
                      <section
                        className={
                          props.HasChatNotifications
                            ? "menu-row"
                            : "menu-row menu-row-disable"
                        }
                        onClick={() => markAllAsRead()}
                      >
                        <i className="feather-check"></i>{" "}
                        {translateText("mark_all_as_read")}
                      </section>
                    </div>
                  </>
                ) : null}
              </>
            )}
          </div>
          <div className="notification-tabs">
            <section className="tabs-holder">
              <div
                className="tab-item"
                onClick={() => handleSelectTab("events-notifs-tab")}
              >
                <p id="events-notifs-tab" className="tab-name active-tab">
                  {translateText("events")}
                </p>
              </div>
              <div
                className="tab-item"
                onClick={() => handleSelectTab("messages-notifs-tab")}
              >
                <p id="messages-notifs-tab" className="tab-name">
                  {translateText("messages")}
                </p>
              </div>
              <span id="notif-tab-indicator"></span>
            </section>
          </div>
          <div className="notification-lists-holder">
            <div className="notification-list" id="event-notifs">
              {props.EventNotifications.length === 0 ? (
                <EmptyState Text={translateText("notif_empty_state")} />
              ) : (
                <React.Fragment>
                  {props.EventNotifications.map((Item) => (
                    <NotificationItem
                      IsEvent
                      IsRead={Item.status === "READ" ? true : false}
                      NotifItem={Item}
                      UpdateEventsList={() => props.UpdateEventsList()}
                      CloseNotifications={() => toggleClose()}
                      LangData={props.LangData}
                      IsMSS={props.IsMSS}
                      IsSuperAdmin={props.IsSuperAdmin}
                    />
                  ))}
                </React.Fragment>
              )}
            </div>
            <div className="notification-list hidden" id="message-notifs">
              {props.ChatNotifications.length === 0 ? (
                <EmptyState Text={translateText("notif_empty_state")} />
              ) : (
                <React.Fragment>
                  {props.ChatNotifications.map((Item) => (
                    <NotificationItem
                      IsEvent={false}
                      IsRead={Item.status === "READ" ? true : false}
                      NotifItem={Item}
                      UpdateMessagesList={() => props.UpdateMessagesList()}
                      CloseNotifications={() => toggleClose()}
                      LangData={props.LangData}
                      IsMSS={props.IsMSS}
                      IsSuperAdmin={props.IsSuperAdmin}
                      RemountICP={() => props.RemountICP()}
                    />
                  ))}
                </React.Fragment>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Notifications;
